module.exports = __webpack_public_path__ + "static/media/dark-modulo-gestao-servico.aee5f214.svg";